import React, { useState, useEffect } from 'react'
import { useStyles } from './HomeStudentSchools_style'
import HomeAPI from 'api/HomeAPI'
import isEmpty from 'lodash.isempty'
import { Box } from '@material-ui/core'
import SectionSubTitle from 'components/SectionSubTitle/SectionSubTitle'
import Button from 'shared/components/Button/Button.jsx'
import { FormattedMessage } from 'react-intl'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'
import SchoolCard from 'cards/SchoolCard/SchoolCard'
import HorizontalCardsSlider from 'components/HorizontalCardsSlider/HorizontalCardsSlider'

const HomeStudentSchools = () => {
    const classes = useStyles()
    const [schools, setSchools] = useState(null)

    useEffect(() => {
        HomeAPI.GetShowcaseSchools().then((response) => {
            setSchools(response.data.featured_schools)
        })
    }, [])

    if (isEmpty(schools)) return null

    return (
        <Box className={classes.schoolSection}>
            <SectionSubTitle
                titleId='landing_home_student.schools.title'
                descriptionId='landing_home_student.schools.description'
            />
            <Box className={classes.schoolBox}>
                <HorizontalCardsSlider shift={300} wrappedArrows>
                    {schools.map((school, index) => {
                        return <SchoolCard school={school} key={index} />
                    })}
                </HorizontalCardsSlider>
            </Box>
            <Box className={classes.showMoreButtonBox}>
                <RouteMapLink page='education'>
                    <Button className={classes.showMoreButton}>
                        <FormattedMessage id='item_index.show_more_button' />
                    </Button>
                </RouteMapLink>
            </Box>
        </Box>
    )
}

export default HomeStudentSchools
